import { render } from "./Games.vue?vue&type=template&id=0fc0765e&scoped=true&ts=true"
import script from "./Games.vue?vue&type=script&lang=ts"
export * from "./Games.vue?vue&type=script&lang=ts"

import "./Games.vue?vue&type=style&index=0&id=0fc0765e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/octopus-lobby/octopus-lobby/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc0765e"]])

export default __exports__